import { Inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

// Pipe
import { WPMediaSize } from '../media-size/media-size.pipe';

// Interfaces
import { IMedia } from 'projects/models/src/public-api';

// Abstracts
import { NgPostTypeProvider } from '../../abstracts';

@Pipe({
    name: 'wpMediaSizeAsync',
})
export class WPMediaSizeAsync implements PipeTransform {

    constructor(
      private dataProvider: NgPostTypeProvider<IMedia>,
      private wpMediaSize: WPMediaSize) {}

    public transform(value: number, ...args: any[]): Promise<string> {
        return this.getMedia(value)
            .pipe(take(1))
            .toPromise()
            .then((media: IMedia) => this.wpMediaSize.transform(media.media_details, args));
    }

    private getMedia(id: number): Observable<IMedia | IMedia[]> {
        return this.dataProvider.get(`/wp-json/wp/v2/media/${id}`);
    }

}
